/**
 * Convert a Java LocalDateTime array [year, month, day, hour, min, sec, nano]
 * or ISO string to an ISO date string.
 */
export function parseDateTime(value: number[] | string | null | undefined): string {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value) && value.length >= 3) {
    const [year, month, day, hour = 0, min = 0, sec = 0] = value;
    return new Date(year, month - 1, day, hour, min, sec).toISOString();
  }
  return '';
}
